import React from 'react';
import { TabsContent } from 'src/components/ui/tabs';
import { clsx } from 'clsx';

interface AnalyticsTabsContentProps {
  tabId: string;
  className?: string;
  children: React.ReactNode;
}

export const AnalyticsTabsContent = ({
  tabId,
  className = '',
  children,
}: AnalyticsTabsContentProps) => {
  return (
    <TabsContent className={clsx('TabsContent p-[20px] mt-0 ', className)} value={tabId}>
      {children}
    </TabsContent>
  );
};
